/* eslint-disable no-console */
import axios from 'axios';

import {STRATEGY_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import useUserStore from '../../../store/userStore/userStore';

const reduction = async (): Promise<any> => {
  const token = useUserStore.getState().userToken;
  const companyID = useCompanyStore.getState().companyId;

  try {
    const response = await axios.request({
      method: CRUDMethods.GET,
      url: `${STRATEGY_BASE_URL}${API_ENDPOINT_JSON.DASHBOARD.getEmissionByPeriod}/${companyID}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {}
    });
    
    return response.data;

  } catch (err) {
    console.log('err:', err);
  }
};

export default reduction;
